<!-- this span is for the header of aside bar  -->
@if (showResizeAerrow) {
  <button class="aside-resize-handle" type="button" title="Drag to resize" (mousedown)="startResize($event)">
    <i class="fa fa-arrows-h" aria-hidden="true"></i>
  </button>
}
<div class="_wf-cf-headerfornewfield">
  <div class="_wf-kk-textforheaderplace"><span class="_wf-cf-text-span-3" (click)="closeAsideBar()"><i class="fa fa-times"></i> </span> {{header}}</div>
  @if (toggler != undefined) {
    <div class="custom-control custom-switch margin-btm-customize mr-3 p-0 table-switch" (click)="toggleOn()">
      <input class="custom-control-input" type="checkbox" [checked]="toggler.multiselect == true">
      <label class="custom-control-label"></label>
      <p class="m-0 p-0">{{toggler.label}}</p>
    </div>
  }
  @if (!commonService.hide_expand_btn) {
    <div class="size-icon" (click)="expandAsidebar($event)" title="Expand/Collapse">
      <i aria-hidden="true" class="fa fa-expand"></i>
      <i aria-hidden="true" class="fa fa-compress"></i>
    </div>
  }
  @if (toggler != undefined && utilService.isMobile()) {
    <div class="collapse-icon asidebaricon" (click)="multiselectScreen($event)" title="Expand/Collapse">
      <i aria-hidden="true" class="fa fa-expand"></i>
      <i aria-hidden="true" class="fa fa-compress" style="display: none;"></i>
    </div>
  }
  <div class="_wf-kk-divinsideheader" (click)="closeAsideBar()"><i class="fa fa-times-circle"></i></div>
</div>
<div class="aside_ui_engine">

</div>

<ng-content></ng-content>
